import "./Home.css";


function About() {

    return (

        <div className="about">
<h1>About Stardew Valley Social</h1>
            <p>
                Welcome to Stardew Valley Social! This is my second ever project and close to my heart due to my love for gaming - and Stardew Valley in particular. 
                Feel free to browse the local's posts and then make a post of your own and see who from Stardew Valley comments on your post!
            </p>
            <p>Visit the explore page to see some NPC's from the wild that you may recognize. Enjoy!
            </p>

        </div>

    )

}
export default About;